import React, { useState } from 'react'
import { Grid, Typography, Box, } from '@mui/material'
import '../../../styles/report.css'
import RYGGHorizontalBar from './RYGGHorizontalBar'
import {motion, AnimatePresence} from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "80",
    "ComponentType": "ADMIN KEY AREA TAB",
    "Visible": "1",
    "Label": "",
    "Sections": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "HEART",
            "Label2": "0",
            "ValueGrade": "3",
            "HelpText": "TBD",
            "InfoBlock": "<p>Heart disease is the leading cause of death and disability in the United States. More than 650,000 people die of heart disease in the U.S. each year. That is 1 in every 4 deaths.</p><p>Heart disease and stroke are among the most widespread and costly health problems facing the nation, accounting for nearly $555 billion in healthcare expenditures and lost productivity annually. That cost is expected to double by 2035.</p><p>The more risk factors present, the higher the likelihood of heart problems or stroke. Some risk factors cannot be changed, but others can be. This report addresses the risk factors that are actionable.</p>",
            "Cards": [
                {
                    "Order": "10",
                    "Visible": "1",
                    "Label": "Total Cholesterol",
                    "Values": [
                        {
                            "Order": "10",
                            "Label": "DOING WELL",
                            "Distribution": "0",
                            "Color": "#209D70"
                        },
                        {
                            "Order": "20",
                            "Label": "CAUTION",
                            "Color": "#FEC957",
                            "Distribution": "0"
                        },
                        {
                            "Order": "30",
                            "Label": "HIGH RISK",
                            "Color": "#E6323A",
                            "Distribution": "0"
                        },
                        {
                            "Order": "40",
                            "Label": "UNKNOWN",
                            "Color": "#666666",
                            "Distribution": "0"
                        }
                    ]
                },
            ]
        }
    ]
}
        
*/
const motionVariants = {
 
  }
const AdminCardTab = (props) => {

    const OrderedSections = [...props.displayValues.Cards].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredSections = OrderedSections.filter((a) => { return a.Visible === '1' })

    const [viewState, setViewState] = useState(0)


    return (
        <Grid container alignItems="row" justifyContent="center" spacing={2}>
            {
                FilteredSections.map((x, i) => {

                    return (
                        <Grid item xs={12} mx={2}>
                            <motion.div variants={motionVariants} whileHover={{scale:1.1}} style={{ height: '100%'}}>	  
                            <Box sx={{backgroundColor:"#FFFFFF"}} px ={2}>

                                <RYGGHorizontalBar displayValues={x} />
                            </Box>
                            </motion.div>
                        </Grid>
                    )
                })
            }
            <Grid item xs={12}>
                <Box mt={2} px ={2}>
                    <Typography variant="body1" dangerouslySetInnerHTML={{ __html: props.displayValues.InfoBlock }}></Typography>
                </Box>
            </Grid>
        </Grid>
    )
}

export default AdminCardTab